import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M4 6a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M16 18a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M6 8v8","key":"svg-3"}],["path",{"d":"M18 11v5","key":"svg-4"}],["path",{"d":"M16 4l4 4m0 -4l-4 4","key":"svg-5"}]]

const IconGitPullRequestClosed = createReactComponent('outline', 'git-pull-request-closed', 'GitPullRequestClosed', __iconNode);

export default IconGitPullRequestClosed;